export default {
  // KycRecordHistory.tsx
  'kyc.history.title': 'Lịch sử đăng ký KYC',
  'kyc.history.memberAccount': 'Tài khoản thành viên',
  'kyc.history.realName': 'Tên thật',
  'kyc.history.idPhoto': 'Giấy tờ tùy thân',
  'kyc.infoImg.documentPhoto': 'Ảnh giấy tờ',
  'kyc.infoImg.handheldPhoto': 'Ảnh cầm giấy tờ',
  'kyc.infoImg.selfiePhoto': 'Ảnh tự chụp',
  'kyc.infoImg.noPhoto': 'Không có ảnh',
  'kyc.history.viewPhoto': 'Xem ảnh',
  'kyc.history.birthDate': 'Ngày sinh',
  'kyc.history.info': 'Thông tin cơ bản',
  'kyc.history.documentType': 'Loại tài liệu',
  'kyc.history.documentCode': 'Số tài liệu',
  'kyc.history.gender': 'Giới tính',
  'kyc.history.nationality': 'Quốc tịch',
  'kyc.history.incomeSource': 'Nguồn thu nhập',
  'kyc.history.monthlyIncomeRange': 'Thu nhập hàng tháng',
  'kyc.history.occupation': 'Nghề nghiệp',
  'kyc.history.currentAddress': 'Địa chỉ hiện tại',
  'kyc.history.permanentAddress': 'Địa chỉ thường trú',
  'kyc.history.birthAddress': 'Nơi sinh',
  'kyc.history.kycCount': 'Số lần đăng ký',
  'kyc.history.operation': 'Thông tin thao tác',
  'kyc.history.submitTime': 'Thời gian gửi',
  'kyc.history.submitter': 'Người gửi',
  'kyc.history.reviewTime': 'Thời gian duyệt',
  'kyc.history.reviewer': 'Người duyệt',
  'kyc.history.failureReason': 'Lý do thất bại',
  'kyc.history.status': 'Trạng thái',
  'kyc.history.status.simple.pending': 'Đang chờ xem xét đăng ký KYC',
  'kyc.history.status.whole.pending': 'Đang chờ xem xét rút KYC',
  'kyc.history.status.simple.success': 'Đăng ký KYC thành công',
  'kyc.history.status.whole.success': 'Rút KYC thành công',
  'kyc.history.status.simple.failed': 'Đăng ký KYC không thành công',
  'kyc.history.status.whole.failed': 'Rút KYC không thành công',
  'kyc.history.status.simple.blacklist': 'Đăng ký KYC danh sách đen',
  'kyc.history.status.whole.blacklist': 'Rút khỏi KYC danh sách đen',
  'kyc.history.status.unknown': 'Trạng thái không xác định',

  'kyc.sup.status.pending': 'Chưa gửi',
  'kyc.sup.status.submit': 'Đã gửi',
  'kyc.sup.status.rejected': 'Bị từ chối',
  'kyc.sup.status.approved': 'Đã được chấp thuận',
  'kyc.sup.approve.confirm.approve': 'Xác nhận rằng yêu cầu bổ sung thông tin KYC của thành viên đã được chấp thuận?',
  'kyc.sup.approve.confirm.reject': 'Xác nhận rằng yêu cầu bổ sung thông tin KYC của thành viên nên bị từ chối?',

  // KycRecordApprove.tsx
  'kyc.approve.title.success': 'Xác nhận phê duyệt',
  'kyc.approve.title.reject': 'Xác nhận từ chối',
  'kyc.update.title.document': 'Cập nhật tài liệu',
  'kyc.approve.confirm.success': 'Xác nhận đặt trạng thái đăng ký KYC này là đã phê duyệt?',
  'kyc.approve.failureReason': 'Lý do thất bại',
  'kyc.approve.failureReason.placeholder': 'Vui lòng nhập lý do thất bại',
  'kyc.approve.error.recordNotExist': 'Dữ liệu không tồn tại',

  // KycRecordData.tsx
  'kyc.data.setSuccess': 'Đặt thành công',
  'kyc.data.setFailed': 'Đặt thất bại',
  'kyc.data.viewFailureReason': 'Xem lý do thất bại',
  'kyc.data.viewHistory': 'Xem lịch sử',
  'kyc.data.document': 'Cập nhật tài liệu',
  'kyc.data.confirm.setFailed': 'Xác nhận đặt trạng thái đăng ký KYC này là thất bại?',
  'kyc.data.error.loadFailed': 'Tải dữ liệu thất bại',

  // KycRecordFrm.tsx
  'kyc.form.submitTime': 'Thời gian gửi',
  'kyc.form.reviewTime': 'Thời gian duyệt',
  'kyc.form.memberAccount': 'Tài khoản thành viên',
  'kyc.form.memberAccount.placeholder': 'Vui lòng nhập tài khoản thành viên',
  'kyc.form.status': 'Trạng thái',
  'kyc.form.status.placeholder': 'Vui lòng chọn trạng thái',
  'kyc.form.status.pending': 'Chờ duyệt',
  'kyc.form.status.success': 'Đã phê duyệt',
  'kyc.form.status.failed': 'Đã từ chối',
  'kyc.form.batchSuccess': 'Đặt hàng loạt thành công',
  'kyc.form.batchFailed': 'Đặt hàng loạt thất bại',
  'kyc.form.confirm.batchFailed': 'Xác nhận đặt trạng thái các đăng ký KYC đã chọn là thất bại?',

  // 系统通用
  'sys.operation.title': 'Thao tác'
};
